import { useEffect } from "react";
import SignupCard from "./components/SignupCard";
import { useAppSelector } from "../../redux/store";
import { useSnackbar } from "notistack";

const Signup = () => {
  const { signUpError, signUpSuccess } = useAppSelector((state) => state.login);

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (signUpSuccess) {
      enqueueSnackbar("Signup successful!", { variant: "success" });
    }
    if (signUpError) {
      enqueueSnackbar(`Signup failed. ${signUpError}.`, { variant: "error" });
    }
  }, [enqueueSnackbar, signUpSuccess, signUpError]);

  return <SignupCard />;
};

export default Signup;
